import gql from 'graphql-tag'
import { BMDialogBuildingFragment } from '@api/fragments'
import { BMDialogBuilding } from '@api/types'
import client from '@stores/apollo'

export default function details(id: string) {
  return client.gql
    .query({ query, variables: { id } })
    .then(({ data: { node: building } }: { data: { node: BMDialogBuilding } }) => building)
}

const query = gql`
  query buildingDetails($id: ID!) {
    node(id: $id) {
      ...BMDialogBuildingFragment
    }
  }
  ${BMDialogBuildingFragment}
`
